import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import _isNil from "lodash/isNil";
import numeral from 'numeral';
import { FORMATS } from '../constants/drivers'; // Configure numeral

numeral.options.scalePercentBy100 = false;
/**
 * Driver value formatter.
 *
 * @param {string} value - The string value to be formatted.
 * @param {format} [format] - The format type.
 * @return {string} - Formatted string.
 */

export var formatValue = function formatValue(value, format) {
  var num = numeral(value);

  switch (format) {
    case FORMATS.CURRENCY:
      return num.format('$0,0');

    case FORMATS.CURRENCY_FRACTIONAL:
      return num.value() !== 0 ? num.format('$0,0.00[0]') : num.format('$0,0');

    case FORMATS.CURRENCY_WITH_CENTS:
      return num.value() !== 0 ? num.format('$0,0.00') : num.format('$0,0');

    case FORMATS.DECIMAL:
      return num.format('0.00');

    case FORMATS.NUMBER:
      return num.format('0,0');

    case FORMATS.PERCENT:
      return num.format('0,0%');

    case FORMATS.PERCENT_WITH_DECIMAL:
      return num.format('0,0.00%');

    case FORMATS.STRING:
    default:
      return value;
  }
};
/**
 * Format a value to have a maximum of 2 decimals.
 * @param {string} value - The string value to be formatted.
 * @return {string} - Formatted string.
 */

export var formatTwoDecimals = function formatTwoDecimals(value) {
  return !_isNil(value) ? formatValue(value, FORMATS.DECIMAL) : 'N/A';
};
/**
 * Provided a min & max number, format it as a percentage range.
 *
 * @param {number} min - The minimum value
 * @param {number} max - The maximum value
 * @param {boolean} [respectZero=false] - Whether to respect zero as valid value
 *  @example
 *  loans verticals often require non-`null` values for fields like `min_variable_apr`
 *
 * @return {string} - The formatted percentage range
 */

export var getPercentageRange = function getPercentageRange(min, max) {
  var respectZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var parsedMin = parseFloat(min);
  var parsedMax = parseFloat(max);
  var hasMin = respectZero ? !Number.isNaN(parsedMin) : !!parsedMin;
  var hasMax = respectZero ? !Number.isNaN(parsedMax) : !!parsedMax;
  var formattedMin = formatTwoDecimals(parsedMin);
  var formattedMax = formatTwoDecimals(parsedMax);

  if (hasMin && hasMax) {
    return "".concat(formattedMin, " - ").concat(formattedMax, "%");
  }

  if (hasMin) {
    return "".concat(formattedMin, "%");
  }

  if (hasMax) {
    return "".concat(formattedMax, "%");
  }

  return null;
};